module.exports = __webpack_public_path__ + "img/my-collect-unselect.5f5376ab.svg";